import React from 'react';
import ToolTip from 'scenes/V2/ToolTip';
import { get } from 'lodash';
import HorizontalRule from 'components/HorizontalRule';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import TrackingService from 'services/TrackingService';
import logoRed from 'logo-red.svg';

const ATSubHeader = ({ at, lastDayCallouts, jobCount, message, noShows, ...props }) => {
  const [showEmail, setShowEmail] = useState(false);
  const [showPhone, setShowPhone] = useState(false);
  const reliabilityScore = get(at, 'reliabilityScore', 'N/A');

  const showContactInformation = () => {
    const { job, tz } = props;
    if (!job) return false;

    return (['confirmed', 'checked_in'].includes(job.currentState) && moment.tz(moment(), tz).isBefore(moment.tz(moment(job.endTime), tz)));
  };

  const callouts = at.callouts + at.noShows + at.deCommits;
  const totalJobsCount = at.shiftsWorked;

  const trackEvent = (eventName) => {
    const eventData = {
      at_id: at.id, jp_id: props.jobPoster?.id, job_id: props.job?.id,
    };
    const trackingService = new TrackingService(props.session);
    trackingService.track({
      event_name: eventName
        .replace(/^JP/, 'JP_')
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
        .toLowerCase(),
      event_data: eventData,
    });
    trackingService.trackMixpanel({
      event_name: eventName,
      event_data: eventData,
    });
  };

  const onClickShowContact = (type) => {
    switch (type) {
      case 'phone':
        setShowPhone(true);
        trackEvent('JPPhoneNoClick');
        break;
      case 'email':
        setShowEmail(true);
        trackEvent('JPEmailClick');
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const fitOrgText = () => {
      const responsiveWidth = 990;
      const minFont = 9;
      const maxFont = 17;

      document.querySelectorAll('.org').forEach(el => {
        if (window.innerWidth >= responsiveWidth) {
          el.style.fontSize = maxFont + 'px';
          while (el.scrollWidth > el.offsetWidth && parseFloat(el.style.fontSize) > minFont) {
            el.style.fontSize = (parseFloat(el.style.fontSize) - 0.5) + 'px';
          }
        } else {
          el.style.fontSize = maxFont + 'px';
        }
      });
    }

    fitOrgText()
    window.addEventListener('resize', fitOrgText);
  }, [])

  return (<React.Fragment>
    <div className="v2-sub-header gotham-medium-font">
      <div className="left-widget">
        <div className="widget-header mr-0">
          <img src={logoRed} alt="Go4 Logo" className="go4-logo" />
          <div className="mt-1">HISTORY</div>
        </div>
        <div className="widget-body mr-0">
          <div className="reliability-score centered">
            {reliabilityScore !== 'N/A' && <div className="number ">{reliabilityScore}</div>}
            {reliabilityScore === 'N/A' && <div className="rookie">Go4 Rookie</div>}

            <div className="den">
              Reliability Score
              <ToolTip
                id="at-reliability"
                bodyText="This score measures the ratio of callouts within 7 days of a shift to the total number of shifts worked by the AT."
              />
            </div>
          </div>
          <div className="shifts-worked centered pr-0">
            <div className="number">{totalJobsCount}</div>
            <div className="den">Shifts Worked</div>
          </div>
          <div className="centered callouts">
            <div className="number">{callouts}</div>
            <div className="den">
              Callouts
              {Number(lastDayCallouts) > 0 && (<div className="notification">
                <span className="red-bullet" />
                <span className="within">
                  {lastDayCallouts + noShows} within 24hrs of shift
                </span>
              </div>)}
            </div>
          </div>
        </div>
      </div>
      <div className="right-widget">
        <div className="widget-header">
          <div className="responsive-text fit-text org">{props.companyName}</div>
        </div>
        <div className="widget-body">
          <div className="centered">
            <div className="number">{jobCount}</div>
            <div className="den">Shifts Worked</div>
          </div>
          <div className="centered">
            {message === 'YES' && <div className="yes">YES</div>}
            {message === 'NO' && <div className="no">NO</div>}
            {['No feedback given.', 'N/A'].includes(message) && (<div className="rookie">Not Rated</div>)}
            <div className="den">Would I Hire Again?</div>
          </div>
        </div>
      </div>
    </div>
    <HorizontalRule dashed margin={10} />
    {showContactInformation() && (<div className="contact-information">
      <h5>Contact information</h5>
      <p>
        <b>Email:</b>{' '}
        {showEmail ? (<span>{at.email}</span>) : (
          <span className="click-to-view" onClick={() => onClickShowContact('email')}>
            Click to view
          </span>)}
      </p>
      <p>
        <b>Phone:</b>{' '}
        {showPhone ? (<span>{at.phoneNumber}</span>) : (
          <span className="click-to-view" onClick={() => onClickShowContact('phone')}>
            Click to view
          </span>)}
      </p>
      <HorizontalRule dashed margin={10} />
    </div>)}
  </React.Fragment>);
};

export default ATSubHeader;
